<template>
    <ul class="exception-settings">
        <li v-if="!placementEnabled">
            <span class="negative">
                Placement Switched Off
            </span>
        </li>
        <li v-if="placementEnabled && placement.reward">
            Reward:
            <span class="font-4">
                {{ placement.reward }} Virtual Item
            </span>
        </li>
        <li v-if="placementEnabled && placement.capping">
            Capping:
            <span class="font-4" v-if="placement.capping.enabled">
                {{ placement.capping.maxImpressions }}/{{ getUnitName(placement.capping.unit) }}
            </span>
            <span v-else class="font-4">Off</span>
        </li>
        <li v-if="placementEnabled && placement.pacing">
            Pacing:
            <span class="font-4" v-if="placement.pacing.enabled">
                1 ad/{{ placement.pacing.numOfMinutes }}min.
            </span>
            <span v-else class="font-4">Off</span>
        </li>
    </ul>
</template>

<script>
import consts from 'services/metaData/consts';

export default {
    name: 'ExceptionSettings',
    props: {
        placement: {
            type: Object,
            required: true
        }
    },
    computed: {
        placementEnabled() {
            return this.placement.enabled === undefined || Number(this.placement.enabled) !== 0;
        }
    },
    methods: {
        getUnitName(unit) {
            return consts.UNIT_NAMES[unit] || unit;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.exception-settings {
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
        margin-bottom: 8px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.negative {
    color: $negative;
}
</style>
